import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const TiersFilter = ({
    contentTiers = [],
    loading = false,
    filters,
    restoreFilterValues,
}) => (
    <Field
        className='--customWidth --contentTiers'
        component={Form.ReduxSelect}
        disabled={loading}
        loading={loading}
        multiple
        name='contentTiers'
        placeholder='Tier'
        options={contentTiers}
        search
        setValue={restoreFilterValues(filters, 'contentTiers')}
    />
);

TiersFilter.propTypes = {
    contentTiers: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};
